import calendarIcon from "../../assets/all-icons/briefcase-blue.png";
import employmentIcon from "../../assets/all-icons/briefcase-green.png";
import walletIcon from "../../assets/all-icons/folder-rectangle-purple.png";
import documentsIcon from "../../assets/all-icons/folder-document-orange-2.png";
import { useInView } from "../../hooks/useInView";

const REQUIREMENTS = [
  {
    icon: calendarIcon,
    iconBg: "#eff6ff",
    label: "AGE",
    labelColor: "#2563eb",
    value: "22–55 years",
    description: "Open to salaried employees and self-employed individuals.",
  },
  {
    icon: employmentIcon,
    iconBg: "#ecfdf5",
    label: "EMPLOYMENT",
    labelColor: "#059669",
    value: "Salaried professionals",
    description:
      "We currently support applicants with a stable source of income.",
  },
  {
    icon: walletIcon,
    iconBg: "#faf5ff",
    label: "MONTHLY INCOME",
    labelColor: "#9333ea",
    value: "₹15,000+ net",
    description: "Your net monthly income should be ₹15,000 or higher.",
  },
  {
    icon: documentsIcon,
    iconBg: "#fff7ed",
    label: "DOCUMENTS",
    labelColor: "#ea580c",
    value: "PAN, Aadhaar and bank statement",
    description: "Keep these documents ready for a smoother application process.",
  },
];

export function Eligibility() {
  const { ref, inView } = useInView<HTMLDivElement>();

  return (
    <section className="w-full bg-white px-4 py-16 sm:py-20">
      <div
        ref={ref}
        className={`mx-auto flex w-full max-w-[1280px] flex-col items-start gap-3 text-left ${inView ? "in-view" : ""}`}
      >
        <span className="reveal-scroll delay-1 rounded-full bg-[#f0fdfa] px-4 py-[6px] text-xs font-semibold uppercase tracking-[0.6px] text-brand-teal">
          Eligibility Criteria
        </span>
        <h2 className="reveal-scroll delay-2 text-3xl font-extrabold leading-tight text-[#1c1917] sm:text-4xl">
          Check your Eligibility
        </h2>
        <p className="reveal-scroll delay-3 max-w-[560px] text-base leading-6 text-[#475569]">
          See the four key requirements to apply in minutes. We've kept the
          process simple, flexible, and transparent.
        </p>
      </div>

      <div className="mx-auto mt-10 grid w-full max-w-[1280px] grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {REQUIREMENTS.map((req) => (
          <div
            key={req.label}
            className="flex flex-col rounded-[20px] border border-solid border-[#e2e8f0] p-6"
          >
            <span
              className="flex h-10 w-10 items-center justify-center rounded-xl"
              style={{ backgroundColor: req.iconBg }}
            >
              <img src={req.icon} alt="" className="h-5 w-5 object-contain" />
            </span>
            <p
              className="pt-4 text-xs font-semibold uppercase tracking-[0.4px]"
              style={{ color: req.labelColor }}
            >
              {req.label}
            </p>
            <p className="pt-1 text-base font-bold leading-5 text-[#1c1917]">
              {req.value}
            </p>
            <p className="pt-2 text-sm leading-5 text-[#64748b]">
              {req.description}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
